import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(period) {
  return axios.get(`agenda`, {params: {...period}})
    .then(response => response.data);
}

function listarByMonth(period) {
  return axios.get(`agendabymonth`, {params: {...period}})
    .then(response => response.data);
}

function buscar(busca) {
  return axios.get(`agenda/buscar?busca=${busca}`)
    .then(response => response.data);
}

function buscarPorCodigo(codigo) {
  return axios.get(`agenda/buscarCodigo?codigo=${codigo}`)
    .then(response => response.data);
}

function abrir(id) {
  return axios.get(`/agenda/${id}`)
    .then(response => response.data);
}

function salvar(evento) {
  return axios.post('/agenda', evento)
    .then(response => response.data);
}

function atualizar(evento) {
  return axios.put(`/agenda/${evento.id}`, evento)
    .then(response => response.data)
}

function confirmarEvento(evento) {
  console.log(evento.confirmado);
  return axios.put(`/agenda/${evento.id}/confirmar`, {confirmado: evento.confirmado})
    .then(response => response.data);
}

function excluir(id) {
  return axios.delete(`/agenda/${id}`)
    .then(response => response.data);
}

function todayEventsCount() {
  return axios.get(`/agenda/today-events-count`)
    .then(response => response.data);
}


export default {
  listar,
  listarByMonth,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  confirmarEvento,
  excluir,
  todayEventsCount
}
